<template lang='html'>
  <div class='done'>
    
    <br/>
    <h3 class="trainingName loud">FERTIG !</h3>
    <br/>
    <img src="../../../assets/images/finished.png" class="trainPic" />
    <div class="clearfix"></div>
    <br/>
    <p class="loud half-press">
      <i class="icon-stopwatch"/> {{ duration }} 
    </p>
    <hr/>
    <table class="table table-sm table-no-head table-left table-middled small">
      <tbody>
        <tr v-for="trn in workout.trainings">
          <td class="cell-3"><img :src="trn.image_url" class="responsive"/></td>
          <td class="cell-6 bold">{{trn.name}}</td>
          <td class="cell-3">
            <p class="no-press" v-for="(x,i) in getExcercises(trn.training_id)">
              <span class="gray">{{i + 1}}:</span> {{ x.reps }}
            </p>
          </td>
        </tr>
      </tbody>
    </table>

  </div>
</template>

<script>
// import { mapGetters } from 'vuex';
export default {
  name: 'workoutFinished',
  props: ['workout', 'duration'],
  data() {
    return {}
  },
  methods: {
    getExcercises(trainID) {
      console.log("getExcercises", trainID, this.workout.excercises)
      return this.workout.excercises.filter( ex => String(ex.training_id) === String(trainID) )
    },
  }
}
</script>

<style lang='scss' scoped>

</style>